/**
 * @param distance - Distance in meters
 * @param locale - Locale string (e.g. 'en-US')
 * @returns Distance formatted as a string in the appropriate unit for the locale
 */
export const convertMetersToLocalUnit = (distance, locale) => {
    switch (locale) {
        case 'en-US':
            return `${Math.round(distance * 3.28084)}ft`;
        default:
            return `${distance}m`;
    }
};
